import React, { Component } from 'react'
import { Card, List, Image, Form, Select, Button, message } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button'

import storageUtils from '../../utils/storageUtils'
import { req_options_cfs_term, req_edit_applycase } from '../../api'

import { API_BASE } from '../../utils/contrains'
import { padLeft } from '../../utils/dataUtil'
import { formateDate } from '../../utils/dateUtil'

const Item = List.Item
const { Option } = Select

export default class MyReviewCaseModify extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        options: []
    }

    componentDidMount() {
        this.api_list_maintainers()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_maintainers = async () => {
        const token = storageUtils.getUser().token
        const result = await req_options_cfs_term('Maintainer', token)
        if (result.total > 0) {
            const categorys = result.data
            this.initOptions(categorys)
        }
    }

    api_modify_applycase = async (applycase) => {
        if (applycase.MaintainerCode === '000000') {
            message.info('請選擇處理人員')
        } else {
            //console.log(applycase)
            const result = await req_edit_applycase(applycase, storageUtils.getUser().token)
            if (result.status === "success") {
                console.log(result)
                message.success(result.message)
                this.props.history.goBack()
            } else {
                message.error(result.message)
            }
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    initOptions = async (categorys) => {
        const options = categorys.reduce((row_pre, row) => {
            row_pre.push({ value: row.value, label: row.label })
            return row_pre
        }, [])

        this.setState({ options })
        //console.log(options)
    }

    // 操作互動處理 //////////////////////////////////////////////

    onFinish = (values) => {
        //console.log('Success:', values);
        const { MaintainerCode } = values
        const { Uid, CaseNid } = this.props.location.state.applycase
        const ReviewerCode = storageUtils.getUser().userCode
        const CaseStatus = 'PROCESS_CASE'
        const condition = 'PROCESSCASE'
        const applycase = {
            Uid: Uid,
            CaseNid: CaseNid,
            ReviewerCode: ReviewerCode,
            MaintainerCode: MaintainerCode,
            CaseStatus: CaseStatus,
            condition: condition
        }
        this.api_modify_applycase(applycase)
    };

    /////////////////////////////////////////////////////////// 

    render() {
        const { options } = this.state
        const { CaseNid, CaseContent, CaseStatusName, RoomCode, ComputerCode, CreatorName,
            ApplyDateTime,
            RecordDescription, Appendices } = this.props.location.state.applycase

        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
                分案處理
            </span>
        )

        return (
            <Card title={title} className='my-review-case-modify'>
                <Form
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        label="處理人員"
                        name="MaintainerCode"
                        initialValue={'000000'}
                    >
                        <Select>
                            <Option value="000000">請指定人員</Option>
                            {
                                options.map(row => <Option value={row.value.toString()} key={row.value}>{row.label}</Option>)
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType="submit">確定</Button>
                    </Form.Item>
                </Form>
                <List>
                    <Item>
                        <span>
                            <span className="left">案件編號：</span>
                            <span>{'N' + padLeft(CaseNid, 7)}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件位置：</span>
                            <span>{RoomCode} / {ComputerCode}</span>
                        </span>
                    </Item>

                    <Item>
                        <span>
                            <span className="left">案件說明：</span>
                            <span>{CaseContent}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">附加照片：</span>
                            <span>
                                {
                                    (Appendices) ?
                                        Appendices.map(img =>
                                        (
                                            <Image
                                                key={img.FileNid}
                                                width={150}
                                                src={API_BASE + img.FileUrl}
                                                alt="" />
                                        )
                                        ) : null
                                }
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">申請時間：</span>
                            <span>{ApplyDateTime ? formateDate(ApplyDateTime) : ''}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">報案人員：</span>
                            <span>{CreatorName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件備註：</span>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: RecordDescription }} />
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件狀態：</span>
                            <span>{CaseStatusName}</span>
                        </span>
                    </Item>
                </List>
            </Card>
        )
    }
}

